import { render, staticRenderFns } from "./MIDDetail.vue?vue&type=template&id=369bae5a&"
import script from "./MIDDetail.vue?vue&type=script&lang=js&"
export * from "./MIDDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports